import React, { useState, useEffect, useRef } from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Layout from 'antd/lib/layout';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import PhoneInput from 'react-phone-input-2';
import { Link, useHistory } from 'react-router-dom';
import { login, registerUser } from '../../API';
import { config } from '../../config';

import lightVars from '../../light.json';
import darkVars from '../../dark.json';
import 'react-phone-input-2/lib/style.css';
import './UserRegistration.less';

// ICONS
import successLogo from './assets/registration-success.svg';
import lightModeIcon from '../../icons/darkmode-off.svg';
import darkModeIcon from '../../icons/darkmode-on.svg';

// IMAGES
import logo from '../../images/logo.png';
import darkModeLogo from '../../images/logo-light.png';

const headerStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
};

const contentStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: '70rem',
};

const { REACT_APP_BUILD_ENV } = config;

const UserRegistration = () => {
  const { Header, Content } = Layout;
  const [theme, setTheme] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const emailRef = useRef(null);

  useEffect(() => {
    const getCurrentTheme = () => {
      const currentTheme = localStorage.getItem('theme-name');

      if (currentTheme === 'light') {
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme(currentTheme);
      } else if (currentTheme === 'dark') {
        localStorage.setItem('app-theme', JSON.stringify(darkVars));
        window.less.modifyVars(darkVars);
        setTheme(currentTheme);
      } else {
        localStorage.setItem('theme-name', 'light');
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme('light');
      }
    };

    getCurrentTheme();
    emailRef.current.focus();
  }, []);

  const register = async () => {
    setIsLoading(true);
    let phoneWithPlusSign = phone;
    if (phone) {
      phoneWithPlusSign = `+${phone}`;
    }
    const response = await registerUser(REACT_APP_BUILD_ENV, email, firstName, lastName, phoneWithPlusSign, password);
    if (response === 201) {
      setRegisterSuccess(true);
    } else {
      setError(response);
    }
    setIsLoading(false);
  };

  const dashboardRedirect = async () => {
    await login(REACT_APP_BUILD_ENV, email, password);
    history.push('/');
  };

  const changeTheme = () => {
    let vars = {};
    let newTheme = '';

    if (theme === 'light') {
      vars = darkVars;
      newTheme = 'dark';
    } else {
      vars = lightVars;
      newTheme = 'light';
    }

    localStorage.setItem('app-theme', JSON.stringify(vars));
    localStorage.setItem('theme-name', newTheme);
    window.less.modifyVars(vars);
    setTheme(newTheme);
  };

  return (
    <Layout>
      <Header className={`app-header-${theme}`} style={headerStyle}>
        <div className="register-header__logo-container">
          <a href="/">
            {theme === 'light' ? (
              <img className="app-header__parity-logo" src={logo} alt="Parity Logo" />
            ) : (
              <img className="app-header__parity-logo" src={darkModeLogo} alt="Parity Logo" />
            )}
          </a>
        </div>
        <div className="app-header__buttons">
          <span role="presentation" onClick={changeTheme}>
            {theme === 'light' ? (
              <img className="app-header__dark-mode" src={lightModeIcon} alt="Light Mode" />
            ) : (
              <img className="app-header__dark-mode" src={darkModeIcon} alt="Dark Mode" />
            )}
          </span>
        </div>
      </Header>
      <Content style={contentStyle}>
        <div className={`user-registration user-registration-${theme}`}>
          {isLoading ? (
            <div className="user-registration-card">
              <div className="user-registration-card--loading">
                <Spin size="large" />
              </div>
            </div>
          ) : (
            <>
              {registerSuccess ? (
                <>
                  <div className="user-registration-spacer-success" />
                  <div className="user-registration-content-success">
                    <div className="user-registration-card-success">
                      <div className="user-registration-card__content-success">
                        <div className="user-registration-card__title-success">
                          Your account has been successfully created!
                        </div>
                        <img className="user-registration-card__success" src={successLogo} alt="sucess" />
                        <div className="user-registration-card__text-success">
                          Now you can monitor your buildings and view real-time energy savings
                        </div>
                        <div className="user-registration__button-wrapper-dashboard">
                          <Button
                            block
                            htmlType="submit"
                            size="large"
                            className="user-registration__button"
                            onClick={() => dashboardRedirect()}
                          >
                            <div className="user-registration__button-text">Go to dashboard</div>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="user-registration-spacer" />
                  <div className="user-registration-content">
                    <div className="user-registration-card">
                      <div className="user-registration-card__content">
                        <div className="user-registration__signup-text">
                          <Link to="/login" className="user-registration__signup-text--blue">
                            Back to sign in
                          </Link>
                        </div>
                        <div className="user-registration-card__title">Create an account</div>
                        {error && <div className="user-registration__error">{error}</div>}
                        <Form
                          layout="vertical"
                          className={`user-registration-card__form app-form-${theme}`}
                          onFinish={() => register()}
                        >
                          <Form.Item
                            name="email"
                            label="Work E-mail Address"
                            className="user-registration__input-wrapper"
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your e-mail',
                              },
                            ]}
                            hasFeedback
                          >
                            <Input
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              size="large"
                              className="user-registration__input"
                              ref={emailRef}
                              style={{ width: '100%', height: '49px', border: '2px solid #bdccd8' }}
                            />
                          </Form.Item>
                          <Form.Item
                            name="firstName"
                            label="First Name"
                            className="user-registration__input-wrapper"
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your first name',
                              },
                            ]}
                          >
                            <Input
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              size="large"
                              className="user-registration__input"
                            />
                          </Form.Item>
                          <Form.Item
                            name="lastName"
                            label="Last Name"
                            className="user-registration__input-wrapper"
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your last name',
                              },
                            ]}
                          >
                            <Input
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              size="large"
                              className="user-registration__input"
                            />
                          </Form.Item>
                          <Form.Item name="phone" label="Phone Number" className="user-registration__input-wrapper">
                            <PhoneInput
                              preferredCountries={['ca', 'us']}
                              value={phone}
                              onChange={(e) => setPhone(e)}
                              enableSearch
                              disableSearchIcon
                              buttonClass="user-registration_phone-button"
                              dropdownClass="user-registration__phone-dropdown"
                              inputClass="user-registration__phone-input"
                            />
                          </Form.Item>
                          <Form.Item
                            name="password"
                            label="Password"
                            className="user-registration__input-wrapper"
                            rules={[
                              {
                                required: true,
                                message: 'Please enter your password',
                              },
                            ]}
                          >
                            <Input.Password
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              size="large"
                              className="user-registration__input"
                            />
                          </Form.Item>
                          <div className="user-registration__button-wrapper">
                            <Button block htmlType="submit" size="large" className="user-registration__button">
                              <div className="user-registration__button-text">Create Account</div>
                            </Button>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </Content>
    </Layout>
  );
};

export default UserRegistration;
